import { useEffect, useState } from "react";

/**
 * Reports whether the viewport is currently below Tailwind's `md` breakpoint
 * (< 768 px). Wraps `matchMedia` so React re-renders when the user rotates
 * their phone or resizes the window.
 *
 * Kept dependency-free on purpose — this is the ONE piece of state that
 * decides between the desktop 3-column layout and the mobile single-pane
 * layout, so any bug here breaks the whole app on the wrong viewport.
 *
 *   const isMobile = useIsMobile();
 */
export function useIsMobile(breakpointPx = 768) {
    const query = `(max-width: ${breakpointPx - 1}px)`;
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.matchMedia(query).matches;
    });
    useEffect(() => {
        if (typeof window === "undefined") return undefined;
        const mql = window.matchMedia(query);
        const onChange = (e) => setIsMobile(e.matches);
        // Safari <14 uses the deprecated addListener API; support both.
        if (mql.addEventListener) mql.addEventListener("change", onChange);
        else mql.addListener(onChange);
        return () => {
            if (mql.removeEventListener) mql.removeEventListener("change", onChange);
            else mql.removeListener(onChange);
        };
    }, [query]);
    return isMobile;
}
